export default `<div class=""><p class="successTitle">Contul dvs. a fost înregistrat cu succes. <br> Completați-vă contul și primiți bonusuri!<br></p>
<style>.successTitle { text-align: center;  color: #140474; font-weight: bold; text-transform: none; margin-bottom: 30px; font-size: 20px;}</style></div>`;
